import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    src: String,
  };

  connect() {
    console.log("[Rinsed] tracking_iframe_controller: connect", { src: this.srcValue });
    this.ready = false;
    this.queue = [];

    window.addEventListener("message", this.handleMessage);
    window.addEventListener("tracking:event", this.handleEvent);

    // If embedded in an iframe, wait for parent params before setting src
    if (this.isEmbeddedInIframe()) {
      console.log("[Rinsed] tracking_iframe_controller: embedded, waiting for parent-params");
      window.addEventListener("tracking:parent-params-set", this.handleParentParams);
      this.parentParamsTimeout = setTimeout(() => {
        console.log(
          "[Rinsed] tracking_iframe_controller: parent-params-set not received within 2s, proceeding without params"
        );
        window.removeEventListener("tracking:parent-params-set", this.handleParentParams);
        this.setIframeSource(this.srcValue);
      }, 2000);
    } else {
      // Set src after listeners are ready
      this.setIframeSource(this.srcValue);
    }
  }

  disconnect() {
    clearTimeout(this.parentParamsTimeout);
    window.removeEventListener("message", this.handleMessage);
    window.removeEventListener("tracking:event", this.handleEvent);
    window.removeEventListener("tracking:parent-params-set", this.handleParentParams);
  }

  isEmbeddedInIframe() {
    return window !== window.top;
  }

  handleParentParams = (event) => {
    console.log("[Rinsed] tracking_iframe_controller: received parent-params-set", event.detail);
    clearTimeout(this.parentParamsTimeout);
    window.removeEventListener("tracking:parent-params-set", this.handleParentParams);
    this.setSrcWithParams(event.detail?.params || {});
  };

  setIframeSource(src) {
    console.log("[Rinsed] tracking_iframe_controller: setting iframe src", { src });
    this.element.src = src;
  }

  setSrcWithParams(params) {
    const url = new URL(this.srcValue);
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        url.searchParams.set(key, value);
      }
    }

    this.setIframeSource(url.toString());
  }

  handleMessage = (event) => {
    if (event.source === this.element.contentWindow && event.data?.type === "ready") {
      console.log("[Rinsed] tracking_iframe_controller: received ready from iframe");
      this.ready = true;
      this.flushQueue();
    }
  };

  handleEvent = (event) => {
    console.log("[Rinsed] tracking_iframe_controller: received tracking:event", event.detail);
    this.postMessage(event.detail);
  };

  postMessage(data) {
    if (this.ready) {
      console.log("[Rinsed] tracking_iframe_controller: sending to iframe (ready)", data);
      this.sendToIframe(data);
    } else {
      console.log("[Rinsed] tracking_iframe_controller: queueing (not ready)", data);
      this.queue.push(data);
    }
  }

  sendToIframe(data) {
    this.element.contentWindow.postMessage(data, "*");
  }

  flushQueue() {
    console.log("[Rinsed] tracking_iframe_controller: flushing queue", {
      queueLength: this.queue.length,
    });
    while (this.queue.length > 0) {
      this.sendToIframe(this.queue.shift());
    }
  }
}
